import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Loading from '../../components/loading';
import TestsList from './components/tests-list';
import useMessageListener from './hooks/useMessageListener';
import { QuizzesViewModel } from './quizzes.vm';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  overflow: hidden;
`;

const Title = styled.h1`
  font-size: 56px;
  font-weight: 700;
  line-height: 48px;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 48px;
    line-height: 52px;
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 1;
  }
`;

export const Quizzes: React.FC = () => {
  const vm = useViewModel(QuizzesViewModel);
  const navigate = useNavigate();
  const handleNavigateToExercises = (message) => {
    if (message.type === 'confirmCountdown') {
      window.onbeforeunload = null;
      navigate(`/exercises/exam/${message.guid}`);
    }
  };

  useMessageListener(handleNavigateToExercises);

  useEffect(() => {
    if (vm.hasError) {
      navigate('/library');
    }
  }, [vm.hasError, navigate]);

  if (vm.isLoading) {
    return <Loading />;
  }

  return (
    <Container>
      <Title>Simulados</Title>
      <TestsList label="Para fazer" tests={vm.toDoQuizzes} />
      <TestsList label="Em breve" tests={vm.comingSoonQuizzes} />
      <TestsList label="Feito" tests={vm.finishedQuizzes} />
    </Container>
  );
};

export default observer(Quizzes);
